import { PRODUCTS } from 'domain'
import { array, bool, func, number, oneOf, shape } from 'prop-types'
import React from 'react'
import { Header, LeadsHomeFinList, LeadsList } from './components'
import { Filters } from './components/Filters'

const propTypes = {
  filters: shape({
    productType: oneOf(['HOME_REFI', 'HOME_FIN', 'AUTO_REFI']),
  }),
  isLoading: bool,
  hasError: bool,
  leads: shape({
    items: array,
    cursors: shape({
      metadata: shape({
        total: number,
      }),
    }),
  }),
  leadsHomeFin: shape({
    indications: array,
    total: number,
  }),
  page: number,
  limit: number,
  changePage: func,
  isOpen: bool,
  closeModal: func,
  goTo: func,
}

const Home = ({
  filters,
  isLoading,
  hasError,
  leads,
  leadsHomeFin,
  page,
  limit,
  changePage,
  leadDetail,
  isOpen,
  closeModal,
  goTo,
  hasFilter,
}) => {

  return (
    <>
      <Header />
      <Filters />
      {!isLoading && !hasError && (
        <>
          {filters.productType !== PRODUCTS.HOME_FIN && (
            <>
              <LeadsList
                leads={leads}
                leadDetail={leadDetail}
                page={page}
                limit={limit}
                changePage={changePage}
                hasFilter={hasFilter}
              />
            </>
          )}
          {filters.productType === PRODUCTS.HOME_FIN && (
            <>
              <LeadsHomeFinList
                leads={leadsHomeFin}
                page={page}
                limit={limit}
                changePage={changePage}
                hasFilter={hasFilter}
              />
            </>
          )}
        </>
      )}
      {!isLoading && hasError && <Error />}
    </>
  )
}

Home.propTypes = propTypes

export { Home }
